import { JoveButton } from '@jove-frontend/mui';
import { Box } from '@mui/material';
import LinkableText from './linkableText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChatMessageCommonCardView = function ChatMessageCommonCardView(props) {
  var _message$options;

  var message = props.message,
      buttonClick = props.buttonClick,
      linkClick = props.linkClick;
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex flex-col space-y-2",
    children: [!!(message !== null && message !== void 0 && message.content) && /*#__PURE__*/_jsx(LinkableText, {
      content: message.content,
      linkClick: linkClick
    }), (message === null || message === void 0 ? void 0 : (_message$options = message.options) === null || _message$options === void 0 ? void 0 : _message$options.length) > 0 && /*#__PURE__*/_jsx(Box, {
      className: "flex flex-col space-y-2",
      children: message.options.map(function (item, index) {
        return /*#__PURE__*/_jsx(JoveButton, {
          variant: "outlined",
          className: "min-w-[120px]",
          onClick: function onClick() {
            return buttonClick(item.label);
          },
          children: item.label
        }, index);
      })
    })]
  });
};

export default ChatMessageCommonCardView;